export default __webpack_public_path__ + "static/logo-e06d898ff185605292490c50be750677.png";